export var white = '#FFFFFF';
export var lightGrey = '#cccccc';
export var mediumGrey = '#999999';
export var black = '#000000';

export var textColor = black;
export var lightBlueColor = '#34a3e7';

export var menuHiliteColor = '#c9eafe';
export var menuSelectedColor = '#82cffd';

export var focusedInputBorderColor = lightBlueColor;
export var unfocusedInputBorderColor = lightGrey;